// extracted by mini-css-extract-plugin
export default {"iconContainer":"socialMediaOverview_iconContainer__yMw8s","icon":"socialMediaOverview_icon__oIhLP"};